import {combineReducers} from 'redux';

import {SelectionSliceFor} from '../../../store/SelectionSliceFor';

// Reserved state. The store and the test harness both carry a `products.selection`
// slice, but this module has no batch action yet: drafts have no delete, and
// publish (FNP-1961) acts on one product. So there is no selection column and no
// selection hook. Add both together when a batch action exists.
const selectionSlice = SelectionSliceFor('products');

export const ProductsReducer = combineReducers({
    selection: selectionSlice.reducer,
});
